"use strict";

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

exports.__esModule = true;

var React = __importStar(require("react"));

var assign_1 = __importDefault(require("core-js/library/fn/object/assign"));

exports.withTheme = function (theme, names) {
  return function (element) {
    if (!theme || !names) {
      return element;
    }

    var themed = typeof names === 'string' ? [theme[names]] : Object.keys(names).filter(function (name) {
      return names[name];
    }).map(function (name) {
      return theme[name];
    });
    var classNames = (element.props.className ? element.props.className.split(' ') : []).concat(themed.filter(function (item) {
      return typeof item === 'string';
    }));
    var styles = [element.props.style].concat(themed.filter(function (item) {
      return typeof item === 'object';
    }));
    var className = classNames.length > 0 ? classNames.join(' ') : undefined;
    var style = styles.length > 0 ? assign_1["default"].apply(void 0, [{}].concat(styles)) : undefined;
    return React.cloneElement(element, {
      className: className,
      style: style
    });
  };
};

exports["default"] = exports.withTheme;